(() => {
  const loader = document.getElementById('khlgan-loader');
  if (!loader || window.Shopify?.designMode) return;
  let revealTimer;
  let dismissTimer;
  const hide = () => {
    window.clearTimeout(revealTimer);
    window.clearTimeout(dismissTimer);
    loader.hidden = true;
  };
  const show = () => {
    hide();
    loader.hidden = false;
    dismissTimer = window.setTimeout(hide, 4500);
  };
  if (document.readyState !== 'complete') {
    revealTimer = window.setTimeout(show, 180);
    window.addEventListener('load', hide, { once: true });
  }
  window.addEventListener('pageshow', hide);
  window.addEventListener('pagehide', hide);
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide();
  });
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !/^https?:$/.test(destination.protocol)) return;
    if (destination.pathname === location.pathname && destination.search === location.search) return;
    if (/\/(cart|checkout|checkouts|account)(\/|$)/.test(destination.pathname)) return;
    window.setTimeout(() => {
      if (!event.defaultPrevented) show();
    }, 0);
  });
})();
